var _rect, _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 64,
    viewBox: "0 0 104 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 103,
    height: 63,
    rx: 4.5,
    stroke: "#313131"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 31.9033,
    r: 17.5,
    fill: "#F79E1B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 31.9033,
    r: 17.5,
    fill: "#EB001B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 45.9044C56.2506 42.7117 59 37.6285 59 31.9031C59 26.1778 56.2506 21.0946 52 17.9019C47.7494 21.0946 45 26.1778 45 31.9031C45 37.6285 47.7494 42.7117 52 45.9044Z",
    fill: "#FF5A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMc);
export default __webpack_public_path__ + "static/media/MC.499c947dabe5b0b00a6d61553d12e84c.svg";
export { ForwardRef as ReactComponent };